import React, { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

interface Props {
  children: ReactNode;
}

/** Protects parent portal routes — redirects non-PARENT users to /login */
const ParentPrivateRoute: React.FC<Props> = ({ children }) => {
  const { isAuthenticated, userClaims } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login/?redirect=/parent/dashboard" replace />;
  }

  if (!userClaims.includes('PARENT')) {
    return <Navigate to="/login/" replace />;
  }

  return <>{children}</>;
};

export default ParentPrivateRoute;
